import { useEffect, useState } from "react";

const MOBILE_THRESHOLD = 768;

const getWidth = (window: Window): number => {
  let w: number = 0;

  if (window.screen) w = window.screen.availWidth;
  else {
    w = window.innerWidth;
  }

  return w;
};

const getIsMobile = (window: Window) => {
  const w = getWidth(window);
  return w <= MOBILE_THRESHOLD;
};

/**
 * This hook doesn't return if the actual device isMobile or not, because we don't care for it
 * we only need a good way to conditionally render some stuff under small devices.
 * @returns
 */
const useDevice = () => {
  const [isMobile, setIsMobile] = useState<boolean>(getIsMobile(window));
  const [width, setWidth] = useState<number>(1920);

  const handleWindowSizeChange = () => {
    setIsMobile(getIsMobile(window));
    setWidth(getWidth(window));
  };

  /**
   * For the first time is rendered
   */
  useEffect(() => {
    setIsMobile(getIsMobile(window));
    setWidth(getWidth(window));
  }, []);

  // /**
  //  * For every change on window size / this is more of an enhancement the focus is on the first render
  //  */
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return { isMobile, width };
};

export default useDevice;
